module.exports = __webpack_public_path__ + "img/side-icon-31.f2278d47.svg";